(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pdp-buy-box"] && !Shopify.designMode) return;
  try {
    class PdpBuyBox extends HTMLElement {
    connectedCallback() {
      this.marker = this.querySelector('[data-subscription-marker]');
      this.quantityInput = this.querySelector('[data-buy-box-quantity]');
      this.addEventListener('change', this.handleChange);
      this.sync();
      window.addEventListener('pageshow', this.handlePageShow);
    }

    disconnectedCallback() {
      window.removeEventListener('pageshow', this.handlePageShow);
    }

    handlePageShow = (event) => {
      if (event.persisted) this.sync();
    };

    handleChange = (event) => {
      const target = event.target;
      if (target && target.dataset && target.dataset.purchaseType) this.sync(target);
    };

    sync(changed) {
      const oneTime = this.querySelector('input[data-purchase-type="one-time"]');
      const subs = Array.from(this.querySelectorAll('input[data-purchase-type="subscription"]'));
      const checkedSub = this.querySelector('input[data-purchase-type="subscription"]:checked');

      let active = checkedSub;
      if (changed) active = changed;
      else if (oneTime && oneTime.checked) active = oneTime;

      const isOneTime = active && active.dataset.purchaseType === 'one-time';

      if (isOneTime) {
        subs.forEach((input) => {
          input.checked = false;
        });
        if (oneTime) oneTime.checked = true;
      } else if (oneTime) {
        oneTime.checked = false;
      }

      if (this.marker) this.marker.disabled = !!isOneTime;
    }
  }

  if (!customElements.get('pdp-buy-box')) {
    customElements.define('pdp-buy-box', PdpBuyBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-sticky-atc"] && !Shopify.designMode) return;
  try {
    class PdpStickyAtc extends HTMLElement {
    connectedCallback() {
      this.optionEl = this.querySelector('[data-sticky-option]');
      this.metaEl = this.querySelector('[data-sticky-meta]');
      this.info = this.querySelector('.pdp-sticky-atc__info');
      this.form = document.getElementById(this.dataset.formId);
      this.buyBox = document.querySelector('pdp-buy-box');
      this.mainButton = this.buyBox ? this.buyBox.querySelector('.pdp-buy-box__submit') : null;

      this.updateLabel();

      // Clicking the left info area scrolls back up to the purchase selector.
      if (this.info) {
        this.info.addEventListener('click', () => this.scrollToSelector());
      }

      // The subscribe/one-time radios are associated to the product form via the
      // form attribute, so their change events do NOT bubble to the form element —
      // they bubble through the pdp-buy-box DOM. Listen on the buy box to stay in sync.
      if (this.buyBox) {
        this.buyBox.addEventListener('change', () => this.updateLabel());
      }

      if (this.mainButton && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            // Show the bar only when the main button has scrolled above the viewport.
            const belowViewport = entry.boundingClientRect.top > 0;
            const show = !entry.isIntersecting && !belowViewport;
            this.hidden = !show;
          },
          { threshold: 0 }
        );
        this.observer.observe(this.mainButton);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    scrollToSelector() {
      const target =
        this.buyBox?.querySelector('.pdp-buy-box__options') ||
        this.buyBox?.querySelector('.pdp-buy-box__heading') ||
        this.buyBox;
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    updateLabel() {
      if (!this.buyBox) return;
      const checked = this.buyBox.querySelector('.pdp-buy-box__input:checked');
      if (!checked) return;

      const option = checked.closest('.pdp-buy-box__option');
      const title = option?.querySelector('.pdp-buy-box__option-title')?.textContent?.trim();
      const badge = option?.querySelector('.pdp-buy-box__badge')?.textContent?.trim();
      const price = option?.querySelector('.pdp-buy-box__prices > span')?.textContent?.trim();

      const saveEl = this.querySelector('[data-sticky-save]');
      if (this.optionEl && title) this.optionEl.textContent = title;
      if (saveEl) saveEl.textContent = badge ? `(${badge})` : '';
      if (this.metaEl) this.metaEl.textContent = price || '';
    }
  }

  if (!customElements.get('pdp-sticky-atc')) {
    customElements.define('pdp-sticky-atc', PdpStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["subscription-selector"] && !Shopify.designMode) return;
  try {
    class SubscriptionPlanSelector extends HTMLElement {
    abortController = new AbortController();

    connectedCallback() {
      const target = this.closest('.shopify-section, dialog');
      target?.addEventListener('variant:update', this.updateForVariant, { signal: this.abortController.signal });
      this.addEventListener('change', this.handlePlanChange, { signal: this.abortController.signal });
      window.addEventListener('pageshow', this.handlePageShow, { signal: this.abortController.signal });
      this.syncPurchaseOption();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    handlePlanChange = (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.dataset.purchaseType) return;
      this.syncPurchaseOption(event.target);
    };

    handlePageShow = (event) => {
      if (!event.persisted) return;

      const defaultPurchaseInput = this.querySelector('input[data-default-purchase-option]');
      if (!(defaultPurchaseInput instanceof HTMLInputElement)) return;

      this.syncPurchaseOption(defaultPurchaseInput);
    };

    syncPurchaseOption = (selectedInput) => {
      const oneTimeInput = this.querySelector('input[data-purchase-type="one-time"]');
      const subscriptionInputs = this.querySelectorAll('input[data-purchase-type="subscription"]');
      const subscriptionInput = this.querySelector('input[data-purchase-type="subscription"]:checked');
      let activeInput = subscriptionInput;
      if (selectedInput instanceof HTMLInputElement) {
        activeInput = selectedInput;
      } else if (oneTimeInput?.checked) {
        activeInput = oneTimeInput;
      }
      const isOneTime = activeInput?.dataset.purchaseType === 'one-time';
      const markerInput = this.querySelector('[data-subscription-marker]');

      if (isOneTime) {
        subscriptionInputs.forEach((input) => {
          input.checked = false;
          input.required = false;
        });
        if (oneTimeInput) oneTimeInput.required = true;
      } else {
        if (oneTimeInput) {
          oneTimeInput.checked = false;
          oneTimeInput.required = false;
        }
        subscriptionInputs.forEach((input) => {
          input.required = true;
        });
      }

      if (markerInput instanceof HTMLInputElement) markerInput.disabled = isOneTime;
      this.syncQuantity(isOneTime ? oneTimeInput : subscriptionInput);
    };

    syncQuantity = (planInput = this.querySelector('input[name="selling_plan"]:checked')) => {
      if (!(planInput instanceof HTMLInputElement)) return;

      const quantity = Math.max(1, Number(planInput.dataset.productQuantity) || 1);
      const hiddenQuantityInput = this.querySelector('[data-subscription-quantity-input]');
      const form = document.getElementById(planInput.getAttribute('form'));
      if (!(hiddenQuantityInput instanceof HTMLInputElement) || !(form instanceof HTMLFormElement)) return;

      const visibleQuantityInput = Array.from(form.elements).find(
        (element) =>
          element instanceof HTMLInputElement &&
          element.name === 'quantity' &&
          element !== hiddenQuantityInput &&
          element.type !== 'hidden'
      );

      if (visibleQuantityInput instanceof HTMLInputElement) {
        hiddenQuantityInput.disabled = true;
        visibleQuantityInput.value = quantity.toString();
        visibleQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        hiddenQuantityInput.disabled = false;
        hiddenQuantityInput.value = quantity.toString();
      }
    };

    updateForVariant = (event) => {
      const eventProductId = event.detail?.data?.productId;
      if (eventProductId && String(eventProductId) !== this.dataset.productId) return;

      const nextSelector = event.detail?.data?.html?.querySelector(
        `subscription-plan-selector[data-block-id="${this.dataset.blockId}"]`
      );
      if (!nextSelector) return;

      this.dataset.productId = nextSelector.dataset.productId;
      const selectedInput = this.querySelector('input[data-purchase-type]:checked');
      const selectedPurchaseType = selectedInput?.dataset.purchaseType;
      const selectedSellingPlanId = selectedPurchaseType === 'subscription' ? selectedInput.value : null;
      this.replaceChildren(...Array.from(nextSelector.childNodes, (node) => node.cloneNode(true)));
      if (selectedPurchaseType === 'one-time') {
        const nextOneTimeInput = this.querySelector('input[data-purchase-type="one-time"]');
        if (nextOneTimeInput instanceof HTMLInputElement) nextOneTimeInput.checked = true;
      } else if (selectedPurchaseType === 'subscription' && selectedSellingPlanId) {
        const nextSubscriptionInput = Array.from(
          this.querySelectorAll('input[data-purchase-type="subscription"]')
        ).find((input) => input.value === selectedSellingPlanId);
        if (nextSubscriptionInput instanceof HTMLInputElement) nextSubscriptionInput.checked = true;
      }
      this.syncPurchaseOption();
    };
  }

  if (!customElements.get('subscription-plan-selector')) {
    customElements.define('subscription-plan-selector', SubscriptionPlanSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
